import React from "react";
import propTypes from "prop-types";
import { withStyles, makeStyles, Tooltip, IconButton } from "@material-ui/core";
import { ReactComponent as ExplicabilityIcon } from "resources/explicabilityIcon.svg";

// eslint-disable-next-line react/prop-types
const ExplicabilityComponent = ({ tooltipText }) => {
  const useStyles = makeStyles(() => ({
    explicabilityTooltip: {
      marginLeft: "3.5px",
    },
  }));

  const CustomTooltip = withStyles({
    tooltip: {
      paddingBottom: "7px",
    },
  })(Tooltip);

  const classes = useStyles();

  return (
    <CustomTooltip
      className={`${classes.explicabilityTooltip}`}
      title={<h3>{tooltipText}</h3>}
      size="small"
    >
      <IconButton>
        <ExplicabilityIcon className={`${classes.explicabilityIcon}`} />
      </IconButton>
    </CustomTooltip>
  );
};

export default ExplicabilityComponent;

ExplicabilityComponent.defaultProps = {
  tooltipText: propTypes.string,
};
